module.exports = {
	"JobDetail.descriptionHeading": "Descrizione",
	"JobDetail.requirementsHeading": "Requisiti",
	"JobDetail.benefitsHeading": "Cosa offriamo",
	"JobDetail.applyLink": "Candidati",
	"Jobs.title": "Lavora con noi",
	"JobList.title": "Lavora con noi",
	"JobList.intro1": "Depop si trova a Londra, nel cuore di Shoreditch, a Milano e a New York.",
	"JobList.intro2": "Vorresti tanto lavorare con noi ma non trovi una posizione che soddisfi i tuoi interessi? Scrivici a work@depop.com e raccontaci di te. Ciò che desideriamo di più è lavorare con persone appassionate tanto quanto noi! Grazie!",
	"Homepage.title": "Homepage",
	"Homepage.greeting": "Depop è l'app più divertente per comprare e vendere, con i tuoi amici, direttamente dalla tua tasca. Segui gli amici per scoprire cosa comprano, cosa vendono e cosa gli piace. Scopri le cose più interessanti dalla community e lasciati ispirare. Vendi semplicemente scattando una foto. Apri il tuo piccolo negozio ora!",
	"Homepage.exploreHeading": "Esplora",
	"ProductSearch.noResults": "Nessun risultato. Per favore prova con un’altra ricerca.",
	"Search.title": "Ricerca",
	"Search.queryPlaceholder": "Cerca oggetti",
	"BuyButton.Buy": "Compra",
	"FollowButton.unfollowLabelLower": "seguendo",
	"FollowButton.followLabelLower": "segui",
	"app.unfollowLabelUpper": "Seguendo",
	"app.followLabelUpper": "Segui",
	"FollowersList.heading": "{name} è seguito da",
	"FollowingList.heading": "{name} sta seguendo",
	"LikeButton.Like": "Piace",
	"LikeButton.Unlike": "Non mi piace più",
	"ShopToggles.Selling": "In vendita",
	"ShopToggles.Likes": "Mi piacciono",
	"ProductComments.showMoreComments": "{count, plural, =0 {0 commenti} one {1 commento} other {Mostra tutti i {count} commenti…}}",
	"ProductComments.collapseComments": "Mostra meno commenti",
	"RelationsModalContent.toggleFollowers": "Mi seguono",
	"RelationsModalContent.toggleFollowing": "Seguendo",
	"RelationsModalContent.close": "Chiudi",
	"RelationsModalContent.noFollowers": "Utente non sta seguendo nessuno",
	"RelationsModalContent.noFollowing": "Utente non sta seguendo nessuno",
	"FeedbackModalContent.toggleSold": "Venduti",
	"FeedbackModalContent.togglePurchased": "Acquistati",
	"FeedbackModalContent.title": "Recensioni",
	"FeedbackModalContent.close": "Chiudi",
	"FeedbackModalContent.noSellerFeedback": "Utente non ha ancora recensioni",
	"FeedbackModalContent.noBuyerFeedback": "Utente non ha ancora recensioni",
	"SocialCounters.followers": "{count, plural, =0 {0 mi seguono} one {1 mi segue} other {{count} mi seguono}}",
	"SocialCounters.following": "{count, plural, =0 {0 seguendo} one {1 seguendo} other {{count} seguendo}}",
	"ProductDetail.title": "{username} sta vendendo su Depop",
	"ProductDetail.numLikes": "{count, plural, =0 {0 piace} one {1 piace} other {{count} piace}}",
	"ShopDetail.noLikedProducts": "A {username} non piace ancora nulla.",
	"ShopDetail.title": "Il negozio di {name}",
	"ShopDetail.noProductsForSale": "{username} non sta ancora vendendo nulla, magari inizierà tra qualche giorno.",
	"ShopLikes.title": "{username} - Piace",
	"ShopFollowers.title": "I seguaci di {username}",
	"ShopFollowers.noFollowers": "{username} non sta seguendo nessuno.",
	"ShopFollowing.title": "{username}sta seguendo",
	"ShopFollowing.noFollowing": "{username} non sta seguendo nessuno.",
	"SuggestedProducts.title": "Oggetti suggeriti",
	"SuggestedUsers.title": "Utenti suggeriti",
	"PasswordResetComplete.matchError": "La password non corrisponde",
	"PasswordResetComplete.serverError": " Si è verificato un problema modificando la password.",
	"PasswordResetComplete.lengthError": "Per favore inserisci una password di almeno 4 caratteri.",
	"PasswordResetComplete.defaultLinkTitle": "Hai dimenticato la tua password?",
	"PasswordResetComplete.invalidLinkTitle": "Il link per modificare la password non è valido",
	"PasswordResetComplete.successLinkTitle": "Evviva!",
	"PasswordResetComplete.passwordPlaceholder": "Nuova password",
	"PasswordResetComplete.passwordAgainPlaceholder": "Riscrivi la password che hai scritto sopra",
	"RequestPasswordReset.invalidMessage": "Oh no, sembra che il link che hai seguito non sia valido. Forse hai già usato questo link per modificare la tua password?",
	"RequestPasswordReset.invalidCta": "Richiedi un nuovo link per modificare la password",
	"RequestPasswordReset.successMessage": "Evviva! La tua password è stata modificata. Ora prova ad accedere a Depop.",
	"RequestPasswordReset.defaultTitle": "Inserisci una nuova password",
	"PasswordResetRequest.error": "Si è verificato un errore, non possiamo modificare la password per questo utente.",
	"PasswordResetRequest.title": "Hai dimenticato la tua password?",
	"PasswordResetRequest.titleSent": "Controlla la tua posta",
	"PasswordResetRequest.cta": "Invia",
	"RequestPasswordReset.formTitle": "Hai dimenticato la tua password?",
	"PasswordResetRequest.formTitleSent": "Controlla la tua posta",
	"PasswordResetRequest.formFieldPlaceholder": "Email o nome utente",
	"RequestPasswordReset.sentMessage": "Controlla la tua posta, dovrebbe essere lì.",
	"RequestPasswordReset.description": "Per ricevere il link e poter modificare la tua password scrivi qui la tua email o il tuo nome utente.",
	"AppBanner.openApp": "Apri nell’app",
	"CommentList.title": "commenti",
	"ProductListItem.cannotBeDisplayed": "Questo prodotto non può essere visualizzato.",
	"TextMeTheApp.close": "Chiudi",
	"TextMeTheApp.heading": "Depop è il modo più semplice e divertente per comperare e vendere. Scopri milioni di oggetti unici e venditori favolosi.  Scarica l’app ora:",
	"TextMeTheApp.message": "Oppure scrivi il tuo numero di telefono, ti invieremo il link per scaricare l’app:",
	"TextMeTheApp.formCancel": "Cancella",
	"TextMeTheApp.formSend": "Invia",
	"Application.defaultDescription": "Depop. Vendi in un attimo, compera con un tocco.",
	"app.blogLabel": "Blog",
	"app.supportLabel": "Supporto",
	"app.profileLabel": "Profilo",
	"app.downloadLabel": "Scarica Depop",
	"app.aboutLabel": "Chi siamo",
	"app.jobsLabel": "Lavora con noi",
	"app.tipsLabel": "Consigli",
	"app.contactLabel": "Contatti",
	"app.searchLabel": "Cerca",
	"app.menuLabel": "Menù",
	"app.loginLabel": "Accedi",
	"GlobalSearch.queryPlaceholder": "Cerca oggetti",
	"app.closeGlobalSearch": "Chiudi",
	"Login.close": "Chiudi",
	"Login.or": "o",
	"Login.loginError": "Qualcosa è andato storto",
	"Login.facebookFailed": "L’accesso con Facebook non è andato a buon fine, per favore prova ad accedere usando la tua email e la tua password. Grazie.",
	"Login.forgotPassword": "Dimenticato?",
	"Login.getTheApp": "Non hai ancora un profilo? Scarica l’app e registrati",
	"LoginForm.usernamePlaceholder": "Nome utente o indirizzo email",
	"LoginForm.passwordPlaceholder": "Password",
	"LoginForm.buttonLabel": "Accedi",
	"FacebookLogin.buttonLabel": "Accedi con Facebook",
	"app.logoutLabel": "Esci",
	"NotFound.title": "Pagina non trovata",
	"NotFound.messageAppLinkText": "vai all’app",
	"NotFound.message": "Ci dispiace, questa pagina non esiste. Per favore prova ancora o {link}",
	"NotFound.smallMessage": "404 pagina non trovata.",
	"FeedbackList.title": "Le recensioni di {name}",
	"FeedbackList.close": "Chiudi",
	"FeedbackList.toggleSold": "Venduti",
	"FeedbackList.togglePurchased": "Acquistati",
	"FeedbackList.emptyState": "{name} non ha ancora lasciato nessun feedback",
	"ProductDetail.similarItems": "Ma c’è di più",
	"ShopDetail.rearrangeButton": "Riordina",
	"ShopManageBar.saveLabel": "Salva",
	"ShopManageBar.cancelRearrange": "Annulla",
	"ShopManageBar.moveSoldItemsDownLabel": "Sposta in basso i venduti",
	"ProductCreate.headline": "Vendi",
	"ProductCreateForm.photosLabel": "Foto",
	"ProductCreateForm.photosHelp": "Puoi caricare fino a 4 foto in formato JPEG oppure PNG.",
	"ProductCreateForm.descriptionLabel": "Descrizione",
	"ProductCreateForm.usernamePlaceholder": "Descrivi il tuo oggetto aggiungendo informazioni relative alle sue condizioni, al brand, al colore e allo stile",
	"ProductCreateForm.categoryLabel": "Categoria",
	"ProductCreateForm.categoryPlaceholder": "Seleziona una categoria",
	"ProductCreateForm.sizeLabel": "Taglia",
	"ProductCreateForm.sizePlaceholder": "Seleziona una taglia",
	"ProductCreateForm.quantityLabel": "Quantità",
	"ProductCreateForm.domesticShippingLabel": "Spedizione Nazionale",
	"ProductCreateForm.internationalShippingLabel": "Spedizione Internazionale",
	"ProductCreateForm.priceLabel": "Prezzo dell'oggetto",
	"ProductCreateForm.sizeRequired": "Seleziona una taglia",
	"ProductCreateForm.quantityRequired": "Please enter quantities",
	"ProductCreateForm.addAnotherSize": "Aggiungi un'altra taglia",
	"ProductCreateForm.addInternationalShipping": "Spedizione internazionale",
	"ProductCreateForm.buttonAnotherLabel": "Salva e continua a vendere",
	"ProductCreateForm.buttonLabel": "Salva",
	"ProductCreateForm.productCreated": "Oggetto salvato",
	"ProductCreateNotConnected.title": "Sembra che il tuo conto PayPal non sia connesso. Per favore connetti PayPal a Depop per iniziare a vendere.",
	"ProductCreateNotConnected.message": "Sembra che il tuo conto PayPal non sia connesso. Per favore connetti PayPal a Depop per iniziare a vendere.",
	"ProductCreateNotLoggedIn.title": "Per poter vendere devi accedere a Depop.",
	"ProductCreateNotLoggedIn.linkText": "accedere",
	"ProductCreateNotLoggedIn.message": "Per poter vendere devi {link} a Depop.",
	"MultiplePictureInput.tooManyImages": "Hai selezionato troppe immagini.",
	"MultiplePictureInput.filesTooSmall": "Uno o più dei tuoi file hanno un formato più piccolo di 1280x1280.",
	"MultiplePictureInput.invalidFormat": "Uno o più dei tuoi file non sono in formato JPEG o PNG.",
	"MultiplePictureInput.dropLabel": "Trascina qui le immagini.",
	"formValidation.required": "Questo campo è obbligatorio",
	"formValidation.maxLength": "Puoi scrivere una descrizione di massimo {value} caratteri",
	"formValidation.minValue": "L'importo minimo è di {value}",
	"formValidation.maxValue": "L'importo massimo è di {value}",
	"formValidation.minArrayLength": "This field has a maximum length of {value}",
	"formValidation.maxArrayLength": "This field has a maximum length of {value}",
	"CropModal.cancel": "Cancella",
	"CropModal.submit": "Salva"
};


//////////////////
// WEBPACK FOOTER
// ../src/locale/it.json
// module id = 945
// module chunks = 17